
import { defineComponent, ref, toRef, onMounted } from "vue"
import Swal from "sweetalert2/dist/sweetalert2.js"
import { hideModal } from "@/core/helpers/dom"
import * as Yup from "yup"

import { useStore } from "vuex"
import { Actions } from "@/store/enums/StoreEnums"
import { ElMessage } from "element-plus"
import type { ElForm } from "element-plus"

import { Product } from "@/store/modules/ProductModule"
import { BoxType } from "@/store/modules/BoxInfoModule"

type FormInstance = InstanceType<typeof ElForm>

export default defineComponent({
  name: "new-box-item-info-modal",
  components: {},
  props: [
    'add_box_item_infos'
  ],
  setup(props) {
    const formRef = ref<FormInstance>()
    const store = useStore()
    const newBoxItemInfoModalRef = ref<null | HTMLElement>(null)

    // 弹窗打开时重置表单 + 自动搜索
    onMounted(() => {
      const el = newBoxItemInfoModalRef.value
      if (el) {
        el.addEventListener('show.bs.modal', () => {
          formData.value.product_brand = ''
          formData.value.ip = ''
          formData.value.is_presale = ''
          formData.value.name = ''
          formData.value.min_price = null
          formData.value.max_price = null
          page.value.currentPage = 1
          tableData.value = []
          query()
        })
      }
    })

    const onSubmit = (formEl: FormInstance | undefined) => {
      console.log('onSubmit')

      let selected_items = tableData.value.filter((i) => {
        return (i as any).selected
      })

      console.log(selected_items)

      props.add_box_item_infos(selected_items)
      tableData.value = []
      hideModal(newBoxItemInfoModalRef.value)
    }

    const onCancel = () => {
      hideModal(newBoxItemInfoModalRef.value);
    }

    const products = ref(Array<Product>())

    // store
    //   .dispatch(Actions.GET_ALL_PRODUCTS)
    //   .then(() => {
    //     products.value = store.getters.currentAllProducts
    //   })
    //   .catch(() => {
    //     // const [error] = Object.keys(store.getters.getErrors);
    //     // Swal.fire({
    //     //   text: store.getters.getErrors[error],
    //     //   icon: "error",
    //     //   buttonsStyling: false,
    //     //   confirmButtonText: "Try again!",
    //     //   customClass: {
    //     //     confirmButton: "btn fw-bold btn-light-danger",
    //     //   },
    //     // });
    //   })

    const formData = ref({
      product_brand: "",
      ip: "",
      is_presale: "",
      name: "",
      min_price: null,
      max_price: null
    })

    const page = ref({
      currentPage: 1,
      pageSize: 10,
      totalResult: 0
    })

    const onPageChange = (e) => {
      page.value.currentPage = e.currentPage
      query()
    }

    const onReset = () => {
      formData.value.product_brand = ''
      formData.value.ip = ''
      formData.value.is_presale = ''
      formData.value.name = ''
      formData.value.min_price = null
      formData.value.max_price = null
    }

    const tableData = ref([])

    const query = () => {
      // 定义查询参数的接口
      interface QueryParams {
        product_brand: string;
        ip: string;
        is_presale: string;
        name: string;
        currentPage: number;
        pageSize: number;
        min_price?: number | null;
        max_price?: number | null;
      }

      // 创建一个新对象，过滤掉 null 值
      const queryParams: QueryParams = {
        product_brand: formData.value.product_brand,
        ip: formData.value.ip,
        is_presale: formData.value.is_presale,
        name: formData.value.name,
        currentPage: page.value.currentPage,
        pageSize: page.value.pageSize,
      }
      
      // 只有当价格为有效正数时才添加到查询参数中
      // el-input-number 清空时可能返回 0/undefined 而非 null，需一并排除
      if (formData.value.min_price) {
        queryParams.min_price = formData.value.min_price
      }
      if (formData.value.max_price) {
        queryParams.max_price = formData.value.max_price
      }

      store
        .dispatch(Actions.GET_PRODUCTS, queryParams)
        .then(() => {
          tableData.value = store.getters.currentProducts
          page.value.totalResult = store.getters.currentProductCount
        })
        .catch(() => {
          ElMessage.error('商品搜索失败，请重试')
        })
    }

    const product_brand_options = ref(Array<BoxType>())

    store
      .dispatch(Actions.GET_PRODUCT_BRAND_OPTIONS)
      .then(() => {
        product_brand_options.value = [{key: '', value: ''}]
        product_brand_options.value = product_brand_options.value.concat(store.getters.currentProductBrandOptions)
      })
      .catch(() => {
        // const [error] = Object.keys(store.getters.getErrors);
        // Swal.fire({
        //   text: store.getters.getErrors[error],
        //   icon: "error",
        //   buttonsStyling: false,
        //   confirmButtonText: "Try again!",
        //   customClass: {
        //     confirmButton: "btn fw-bold btn-light-danger",
        //   },
        // });
      })

    const product_ip_options = ref(Array<BoxType>())

    store
      .dispatch(Actions.GET_PRODUCT_IP_OPTIONS)
      .then(() => {
        product_ip_options.value = [{key: '', value: ''}]
        product_ip_options.value = product_ip_options.value.concat(store.getters.currentProductIpOptions)
      })
      .catch(() => {
        // const [error] = Object.keys(store.getters.getErrors);
        // Swal.fire({
        //   text: store.getters.getErrors[error],
        //   icon: "error",
        //   buttonsStyling: false,
        //   confirmButtonText: "Try again!",
        //   customClass: {
        //     confirmButton: "btn fw-bold btn-light-danger",
        //   },
        // });
      })

    const presale_options = ref(Array<BoxType>())
    presale_options.value = [{key: '', value: ''}, {key: '是', value: 'true'}, {key: '否', value: 'false'}]

    const submitEvent = () => {
      query()
    }

    const formatPrice = (price: number | string | null | undefined): string => {
      if (price === null || price === undefined) return '0.0'
      const num = Number(price)
      return isNaN(num) ? '0.0' : num.toFixed(1)
    }

    return {
      newBoxItemInfoModalRef,
      onSubmit,
      formRef,
      products,
      onCancel,
      formData,
      onPageChange,
      tableData,
      page,
      product_brand_options,
      product_ip_options,
      presale_options,
      submitEvent,
      onReset,
      formatPrice
    };
  },
});
